class autoCalendarDate {
  miladiDate = document.querySelectorAll(".miladi");
  miladiYearDOM = document.querySelector(".miladiY");
  weekDay = document.querySelectorAll("#week-day");
  miliSecondDay = 86400000;
  firstLeapYearshamsi = 1399;
  daysPassedResult;

  // prettier-ignore
  shamsiMonthArr = ["farvardin", "ordibehesht",'khordad','tir','mordad','shahrivar','mehr','aban','azar','dey','bahman','esfand'];
  // prettier-ignore
  shamsiMonthObj = { 'farvardin': 31 ,'ordibehesht':31 ,'khordad':31,'tir':31,'mordad':31,'shahrivar':31,'mehr':30,'aban':30,'azar':30,'dey':30,'bahman':30, "esfand": this.isLeapYear(this.shamsiCurrentYear,this.firstLeapYearshamsi) ? 30 : 29
}

  miladiYear =
    this.shamsiMonthArr.indexOf(this.slug()) >=
    this.shamsiMonthArr.indexOf("dey")
      ? +this.shamsiCurrentYear() + 622
      : +this.shamsiCurrentYear() + 621;

  isLeapYear(currentYear, firstleapYear) {
    return (currentYear - firstleapYear) % 4 === 0;
  }

  constructor() {
    if (!this.shamsiMonthArr.includes(this.slug())) return;
    this.daysPassedResult = this.daysPassed(this.slug());
    this.renderMiladiDate();
    this.renderWeekday();
  }

  shamsiCurrentYear() {
    return new Intl.DateTimeFormat("en-US", {
      calendar: "persian",
      year: "numeric",
    })
      .format(new Date())
      .split(" ")[0];
  }

  slug() {
    return window.location.pathname
      .split("")
      .filter((item) => item !== "/")
      .join("");
  }

  CountFromDate() {
    return this.isLeapYear(this.shamsiCurrentYear, this.firstLeapYearshamsi)
      ? `${+this.shamsiCurrentYear() + 621}-03-20`
      : `${+this.shamsiCurrentYear() + 621}-03-21`;
  }

  daysPassed(month) {
    let arrIndex = this.shamsiMonthArr.indexOf(month);
    let daysPassed =
      this.shamsiMonthArr
        .filter((item, i) => i < arrIndex)
        .reduce((acc, item) => acc + this.shamsiMonthObj[item], 0) *
      this.miliSecondDay;
    return daysPassed;
  }

  renderMiladiDate() {
    // 1) this part is for miladi days
    this.miladiDate.forEach(
      (day, i, arr) =>
        (day.textContent = new Date(
          +new Date(this.CountFromDate()) +
            this.daysPassedResult +
            (i - 1) * this.miliSecondDay
        ).getDate())
    );
    // 2) this part is for miladi year
    this.miladiYearDOM.textContent = `(${this.miladiYear})`;
  }

  renderWeekday() {
    this.weekDay.forEach(
      (day, i) =>
        (day.textContent = new Intl.DateTimeFormat("fa-IR", {
          calendar: "persian",
          weekday: "long",
        }).format(
          +new Date(this.CountFromDate()) +
            this.daysPassedResult +
            (i - 1) * this.miliSecondDay
        ))
    );
  }
}

export default new autoCalendarDate();
